<template>
    <div>
        <DefaultMenu>
            <template #title>
                Declaraciones
            </template>
     
            <b-button
                v-permission="'declaraciones-menu-crear'"
                v-b-modal.createModal
            >
                Crear <b-icon icon="journal-check" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'declaraciones-menu-notificaciones'"
                v-b-modal.notificacionesModalStatement
                class="ms-1"
            >
                Notificaciones procesadas <b-icon icon="mailbox" font-scale="1"></b-icon>
            </b-button>
            <b-button
                v-permission="'declaraciones-menu-notificaciones'"
                v-b-modal.notificacionesModalAssignmentStatement
                class="ms-1"
            >
                Plantillas asignadas <b-icon icon="people" font-scale="1"></b-icon>
            </b-button>
            
            <template #right>
                <b-button
                    v-permission="'declaraciones-reportes'"
                    v-b-modal.reportModalStatement
                    class="me-2"
                >
                    <b-icon icon="file-earmark-pdf" font-scale="1"></b-icon>
                </b-button>

                <b-button
                    v-permission="'declaraciones-configuracion'"
                    @click="modalShowSetting = true"
                    title="Configuración"
                    v-b-tooltip.hover.left
                >
                    <b-icon icon="gear"/>
                </b-button>
            </template>
        </DefaultMenu>
        
        <BaseModal v-model="modalShowSetting" size="xl">
            <StatementSetting></StatementSetting>
        </BaseModal>

        <!-- Modal -->
        <b-modal
            v-model="modalShowCreate"
            hide-footer
            id="createModal"
            title="Crear una reunión"
            size="lg"
            centered
            scrollable
            header-bg-variant="dark"
            class="m-0 p-0"
        >
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>
            </template>
            <StatementCreate></StatementCreate>
        </b-modal>

        <b-modal
            v-model="modalShowNotifications"
            hide-footer
            id="notificacionesModalStatement"
            title="Notificaciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>

            </template>

            <StatementNotificationList></StatementNotificationList>

        </b-modal>

        <b-modal
            v-model="modalShowAssignmentNotifications"
            hide-footer
            id="notificacionesModalAssignmentStatement"
            title="Notificaciones Asignaciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>

            </template>

            <StatementNotificationAssignmentList></StatementNotificationAssignmentList>

        </b-modal>

        <b-modal
            v-model="modalShowReport"
            hide-footer
            id="reportModalStatement"
            title="Reporte de Declaraciones"
            size="xl"
            centered
            scrollable
            header-bg-variant="dark"
        >
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close">
                    Cerrar
                </b-button>
            </template>
            <StatementReport></StatementReport>
        </b-modal>
    </div>
</template>
<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'
import BaseModal from '@/components/shared/Base-modal.vue'
import StatementNotificationList from "@/components/Statements/StatementMenu/Statement-notification-list.vue";
import StatementCreate from "@/components/Statements/StatementMenu/Statement-create.vue";
import StatementSetting from "@/components/Statements/StatementMenu/Statement-setting.vue";
import StatementReport from "@/components/Statements/Statement-report.vue";
import StatementNotificationAssignmentList from "@/components/Statements/StatementMenu/Statement-notification-assignment-list.vue";

export default {
    name: 'StatementsMenu',
    
    components: {
        StatementNotificationList,
        StatementCreate,
        DefaultMenu,
        StatementSetting,
        BaseModal,
        StatementReport,
        StatementNotificationAssignmentList
    },

    data() {
        return {
            modalShowCreate: false,
            modalShowNotifications: false,
            modalShowSetting: false,
            modalShowReport: false,
            modalShowAssignmentNotifications: false
        }
    },
}
</script>